const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/lists/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { newsletterSearchQuerySchema } from "@circle-react/components/SettingsApp/Newsletters/searchQuerySchema";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const newsletterListsSearchSchema = z.object({
  query: newsletterSearchQuerySchema
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter/lists/")({
  validateSearch: newsletterListsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});